@if (appraisal) {
  <section class="row appraisal-info">
    @if (!isAppraisalEmpty) {
      <div class="col-12">
        <div class="primary-info-box">
          <div class="row date-row date-head">
            <div class="col-12 text-align-left">
              <h3 class="h-main h-main-medium">{{ 'appraisal_result_title' | translate }}</h3>
            </div>
          </div>
          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.roadType) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_road_type' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-type">{{
                  appraisal.mortgagesAppraisalData.appraisalAddress.roadType | translate
                }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.roadName) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_road_name' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-name">{{
                  appraisal.mortgagesAppraisalData.appraisalAddress.roadName
                }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.roadNumber) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_road_number' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-number">{{
                  appraisal.mortgagesAppraisalData.appraisalAddress.roadNumber
                }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.floor) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_floor' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-floor">{{
                  appraisal.mortgagesAppraisalData.appraisalAddress.floor
                }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.door) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_door' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-door">{{ appraisal.mortgagesAppraisalData.appraisalAddress.door }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.zip) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_postal_code' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-zip">{{ appraisal.mortgagesAppraisalData.appraisalAddress.zip }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.city) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_city' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-city">{{ appraisal.mortgagesAppraisalData.appraisalAddress.city }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.appraisalAddress?.province) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_province' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-road-province-name">{{ province?.name }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (appraisal?.mortgagesAppraisalData?.cadastralData?.length > 0) {
      <div class="col-12">
        <div class="primary-info-box">
          <div class="row date-row date-head">
            <div class="col-12 text-align-left">
              <h3 class="h-main h-main-medium">{{ 'appraisal_result_appraisal_refs' | translate }}</h3>
            </div>
          </div>
          <div *ngFor="let catastral of appraisal?.mortgagesAppraisalData?.cadastralData; let i = index">
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span class="ref">{{ 'appraisal_result_appraisal_ref' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span class="ref" [id]="'appraisal-resul-catastral-reference-' + i">{{ catastral.reference }}</span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_property_type' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-type-catastral-reference-' + i">
                  {{ 'APPR_TYPE_ASSETS_' + catastral?.typeAsset | translate }}
                </span>
              </div>
            </div>

            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_registry' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-registry-' + i">
                  {{ 'APPR_REGISTRY_' + catastral?.propertyRegistry?.registry | translate }}
                </span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_registry_number' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-registryNumber-' + i">
                  {{ catastral?.propertyRegistry?.registryNumber }}
                </span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_farm_number' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-farmNumber-' + i"> {{ catastral?.propertyRegistry?.farmNumber }} </span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_volume' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-volume-' + i"> {{ catastral?.propertyRegistry?.volume }} </span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_book' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-book-' + i"> {{ catastral?.propertyRegistry?.book }} </span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_folio' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-folio-' + i"> {{ catastral?.propertyRegistry?.folio }} </span>
              </div>
            </div>
            <div class="row date-row w-border">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_label_idufir' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span [id]="'appraisal-resul-idufir-' + i"> {{ catastral?.idufir }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (appraisal?.mortgagesAppraisalData?.nameCurrentOwner || appraisal?.mortgagesAppraisalData?.phoneCurrentOwner) {
      <div class="col-12">
        <div class="primary-info-box">
          <div class="row date-row date-head">
            <div class="col-12 text-align-left">
              <h3 class="h-main h-main-medium">{{ 'appraisal_result_contact_data_appraisal' | translate }}</h3>
            </div>
            <div class="col-sm-4 col-12">
              <h3 class="amount"></h3>
            </div>
          </div>
          @if (appraisal?.mortgagesAppraisalData?.nameCurrentOwner) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_name' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-name-current-owner">{{
                  appraisal.mortgagesAppraisalData.nameCurrentOwner
                }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalData?.phoneCurrentOwner) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_phone' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-phone-current-owner">{{
                  appraisal.mortgagesAppraisalData.phoneCurrentOwner
                }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (!isAppraisalCRMEmpty) {
      <div class="col-12">
        <div class="primary-info-box">
          <div class="row date-row date-head">
            <div class="col-12 text-align-left">
              <h3 class="h-main h-main-medium">{{ 'appraisal_result_result_appr' | translate }}</h3>
            </div>
          </div>
          <div class="row date-row">
            <div class="col-sm-8 col-12 text-align-left">
              <h3 class="ref">{{ 'appraisal_result_amount_appraisal' | translate | uppercase }}</h3>
            </div>
            <div class="col-sm-4 col-12">
              @if (appraisal?.mortgagesAppraisalCrmData?.appraisalAmount) {
                <h3 id="appraisal-resul-appraisal-amount" class="bold">
                  {{ appraisal.mortgagesAppraisalCrmData.appraisalAmount | number: '1.2-2' }} €
                </h3>
              }

              @if (!appraisal?.mortgagesAppraisalCrmData?.appraisalAmount) {
                <h3 id="appraisal-resul-pending-appraisal-amount" class="ref">
                  {{ 'appraisal_result_reviewed_by_manager' | translate }}
                </h3>
              }
            </div>
          </div>

          @if (!appraisal?.mortgagesAppraisalData?.appraisal && appraisal?.mortgagesAppraisalCrmData?.appraisalCost) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_cost_appraisal' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-appraisal-cost"
                  >{{ appraisal.mortgagesAppraisalCrmData.appraisalCost | number: '1.2-2' }} €</span
                >
              </div>
              <div class="col-md-8 col-12">
                <p class="info-text-secondary">{{ 'appraisal_result_bonus_appraisal' | translate }}</p>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalCrmData?.appraisalDate) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_date_appraisal' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span>{{ appraisal.mortgagesAppraisalCrmData.appraisalDate | date: "d 'de' MMMM y" }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalCrmData?.plannedDateVisitHome) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_planned_date_visit' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-planned-date-visit-home">{{
                  appraisal.mortgagesAppraisalCrmData.plannedDateVisitHome | date: "d 'de' MMMM y"
                }}</span>
              </div>
            </div>
          }

          @if (appraisal?.mortgagesAppraisalCrmData?.visitDateHome) {
            <div class="row date-row">
              <div class="col-sm-8 col-12 text-align-left">
                <span>{{ 'appraisal_result_date_visit' | translate }}</span>
              </div>
              <div class="col-sm-4 col-12">
                <span id="appraisal-resul-date-visit-home">{{
                  appraisal.mortgagesAppraisalCrmData.visitDateHome | date: "d 'de' MMMM y"
                }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </section>
}
